import { ICommit } from "@/shared-models/ICommit";
import { ICompany } from "@/apps/dashboard/models/IDashboardState";

/**
 * ACTIONS
 */
const actions = {
  setLastName: ({ commit }: ICommit, payload: string): void => {
    commit("SET_LAST_NAME", payload);
  },
  setFirstName: ({ commit }: ICommit, payload: string): void => {
    commit("SET_FIRST_NAME", payload);
  },
  setPhone: ({ commit }: ICommit, payload: string): void => {
    commit("SET_PHONE", payload);
  },
  setEmail: ({ commit }: ICommit, payload: string): void => {
    commit("SET_EMAIL", payload);
  },
  setLocale: ({ commit }: ICommit, payload: string): void => {
    commit("SET_LOCALE", payload);
  },
  setSelectedCompany: ({ commit }: ICommit, payload: string): void => {
    commit("SET_SELECTED_COMPANY", payload);
  },
  setUserRequiresTwoFactor: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_USER_REQUIRES_TWO_FACTOR", payload);
  },
  setTwoFactorEnrolled: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_TWO_FACTOR_ENRROLED", payload);
  },
  setEmailHash: ({ commit }: ICommit, payload: string): void => {
    commit("SET_EMAIL_HASH", payload);
  },
  setCompanies: ({ commit }: ICommit, payload: ICompany[]): void => {
    commit("SET_COMPANIES", payload);
  },
  clearUserData: ({ commit }: ICommit): void => {
    commit("CLEAR_USER_DATA");
  },
};

export default actions;
